import { FormattedMessage } from 'react-intl';
import { useMatch } from 'react-router-dom';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Empty as EmptyCards } from '@sorare/core/src/components/cards/Empty';
import { MLB_MY_CARDS_VAULT_TYPE as ANY_SPORT_MY_CARDS_VAULT_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { filters } from '@sorare/core/src/lib/glossary';

import { EmptyVaultPlaceholderSealed } from 'components/sealing/EmptyVaultPlaceholderSealed';
import { useFiltersCount } from 'search/FiltersManager/useFiltersCount';
import { SearchTopic } from 'searchCards/AdvancedCardSearch/types';

import { EmptyMarket } from './EmptyMarket';
import { NoResults } from './NoResults';

interface Props {
  isGallery: boolean;
  topic?: SearchTopic;
}

export const Empty = ({ isGallery, topic }: Props) => {
  const filtersCount = useFiltersCount({ countSealed: false });
  const matchRoute = useMatch(ANY_SPORT_MY_CARDS_VAULT_TYPE);

  const rarityFromVaultRoute = matchRoute?.params.type;

  if (rarityFromVaultRoute) {
    return (
      <EmptyVaultPlaceholderSealed rarity={rarityFromVaultRoute as Rarity} />
    );
  }

  const title = topic?.label ? (
    <FormattedMessage
      {...filters.noCardsOfTopicFound}
      values={{ topic: topic.label }}
    />
  ) : (
    <FormattedMessage {...filters.noCardsFound} />
  );

  const galleryCTA = isGallery ? null : <EmptyMarket />;
  const description = filtersCount > 0 ? <NoResults /> : galleryCTA;

  return <EmptyCards title={title} description={description} />;
};
